import { useEnv } from '../../environment/useEnv'
import { UserMenu } from './UserMenu'

export function NavigationBar() {
  const { ACCOUNT_TOOL_URL } = useEnv()

  return (
    <div className="mb-5 px-5 py-3 max-w-6xl bg-white border-noround shadow-1 border-none flex justify-content-center">
      <div className="max-w-app flex justify-content-between max-w-screen-xl flex-grow-1">
        <a href={ACCOUNT_TOOL_URL} className="flex">
          <img src="/logo.svg" alt="App Logo" className="w-auto w-8rem" />
        </a>
        <UserMenu />
      </div>
    </div>
  )
}
